import config from '../config';
import http from '@/utils/http';
import { decodeBase64UTF8 } from '@/helpers/utils';
import { logger } from '@/utils/screenEventsLogger';

export const apiFetchICSFile = async (icsUrl) => {
  try {
    const apiUrl = `${config.apiUrl}userapi/proxy-download`;
    const response = await http.get(apiUrl, {
      'axios-retry': { retries: 0 },
      params: { url: icsUrl },
    });

    let icsText;

    if (typeof response.data === 'string') {
      icsText = decodeBase64UTF8(response.data);
    } else if (response.data && response.data.content) {
      icsText = decodeBase64UTF8(response.data.content);
    } else {
      throw new Error('Invalid response format from proxy');
    }

    if (
      icsText.trim().toLowerCase().startsWith('<!doctype') ||
      icsText.trim().toLowerCase().startsWith('<html')
    ) {
      throw new Error(
        'Invalid ICS URL: received HTML instead of calendar data. Please use the iCalendar format URL from Google/Outlook/Apple Calendar settings.',
      );
    }

    if (!icsText.includes('BEGIN:VCALENDAR')) {
      throw new Error('Invalid ICS file: missing VCALENDAR data');
    }

    return icsText;
  } catch (error) {
    logger.addLog(`Calendar ICS fetch failed: ${error?.message}. URL: ${icsUrl}`);

    return null;
  }
};
